import React from 'react';
import { Button, Typography } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '@packages/api-client';
import { useEmbedMode } from '../hooks/useEmbedMode';

const { Text } = Typography;

const AppHeader: React.FC = () => {
  const navigate = useNavigate();
  const isEmbed = useEmbedMode();

  const handleLogout = async () => {
    try {
      await apiClient.logout();
    } catch {
      // 即使 logout 请求失败，token 也会被清除
    }
    navigate('/login', { replace: true });
  };

  // 嵌入模式下隐藏 AppHeader
  if (isEmbed) {
    return null;
  }

  return (
    <header className="flex items-center justify-between px-4 h-12 bg-white border-b border-gray-200">
      <Text className="!text-sm !font-medium !text-gray-600">Agent运行时</Text>
      <Button type="text" size="small" onClick={handleLogout}>
        <LogoutOutlined /> 退出
      </Button>
    </header>
  );
};

export default AppHeader;
